import { Box, Button } from "@mui/material";
import type React from "react";
import { useState } from "react";
import type { OverviewForm } from "../../../hooks/useOverview.ts";
import Collectibles from "./tiles/Collectibles.tsx";
import Locomotives from "./tiles/Locomotives.tsx";
import Others from "./tiles/Others.tsx";
import PersonalVehicles from "./tiles/PersonalVehicles.tsx";
import UtilityVehicles from "./tiles/UtilityVehicles.tsx";
import { capitalizeFirstLetter } from "../Utils/Capitalize.tsx";
import { useGetApiAssetcategories } from "../../../api/rest/generated/asset-categories/asset-categories.ts";
import Electronics from "./tiles/Electronics.tsx";
import Computers from "./tiles/Computers.tsx";
import Mobiles from "./tiles/Mobiles.tsx";

//
// This block of code wasn't on DEV! (verze: 3.1.0 pátek 20. 06. 2025 12:09:13)
//
// const resetCarFilterArray = [ 1, 2 ];
//
// const closeElectronicsArray = [ 6, 7, 8 ];

interface TilesFilterProps {
	overviewForm: OverviewForm;
	onTileClick: () => void;
}

const TileTypes = {
  Osobní_vozidla: "Osobní_vozidla",
  Užitková_vozidla: "Užitková_vozidla",
  Kolejová_vozidla: "Kolejová_vozidla",
  Sběratelství: "Sběratelství",
  Ostatní: "Ostatní",
  Elektronika: "Elektronika",
  Počítače: "Počítače",
  Telefony: "Telefony",
} as const;

type TileType = typeof TileTypes[keyof typeof TileTypes];

type CategoryTile = {
  id: number;
  catName: TileType;
};

const getTile: React.FC<{
  categoryTile: CategoryTile,
  currentValue: number,
  onClick: ()=>void;
}> = ({categoryTile, currentValue, onClick}) => {

  let element = null;

  switch (categoryTile.catName.replace(" ", "_")) {
    case TileTypes.Osobní_vozidla:
      element = <PersonalVehicles selected={currentValue === categoryTile.id}/>;
    break;
    case TileTypes.Užitková_vozidla:
      element = <UtilityVehicles selected={currentValue === categoryTile.id}/>;
    break;
    case TileTypes.Kolejová_vozidla:
      element = <Locomotives selected={currentValue === categoryTile.id}/>;
    break;
    case TileTypes.Sběratelství:
      element = <Collectibles selected={currentValue === categoryTile.id}/>;
    break;
    case TileTypes.Ostatní:
      element = <Others selected={currentValue === categoryTile.id}/>;
    break;
    //
    // These tiles were commented on DEV, where they weren't even created (verze: 3.1.0 pátek 20. 06. 2025 12:09:13).
    // But they were created on new branch (2026 one).
    //
    case TileTypes.Elektronika:
      element = <Electronics selected={currentValue === categoryTile.id}/>;
    break;
    case TileTypes.Počítače:
      element = <Computers selected={currentValue === categoryTile.id}/>;
    break;
    case TileTypes.Telefony:
      element = <Mobiles selected={currentValue === categoryTile.id}/>;
    break;
    default:
      throw new Error("Neznámá kategorie");
  }

  if(element) {
      return (
        <Button sx={{textTransform: "none"}} color="secondary" onClick={onClick}>
          {element}
        </Button>
      )
  }

  return null;
};

export const TilesFilter: React.FC<TilesFilterProps> = ({overviewForm, onTileClick}) => {
	const [showTiles, setShowTiles] = useState(false);
  const categoriesData = useGetApiAssetcategories().data?.data ?? [];
  const tilesNameIds: CategoryTile[] = categoriesData.map((cat) => {
    return {id: cat.id, catName: capitalizeFirstLetter(cat.name) as TileType};
  });


	return (
		<overviewForm.Field name="AssetsCategoryId">
			{(fieldApi) => {
        const currentValue = fieldApi.state.value;//.parsedFilter.AssetsCategoryId;

        //
        // This block of code wasn't on DEV! (verze: 3.1.0 pátek 20. 06. 2025 12:09:13)
        //
        // const resetCarAttributesFilter = () => {
					// fieldApi.form.setFieldValue("sort", "undefined");
        // };
        //
        // const handleClose = () => {
        //   setShowTiles(false);
        // };

				const handleChange = (value: number) => {
          //
          // This block of code wasn't on DEV!
          //
          // if (!resetCarFilterArray.some((item) => item === valueToUpdateWith)) {
          //   resetCarAttributesFilter();
          // }
          // if (!closeElectronicsArray.some((item) => item === valueToUpdateWith)) {
          //   handleClose();
          // }

          if( value !== currentValue) {
            fieldApi.setValue(value);
						onTileClick();
					}
				};

        const finalTiles: React.ReactElement[] = tilesNameIds.map((item, index) => {
				return (
            getTile({categoryTile: item, currentValue: currentValue, onClick: () => handleChange(item.id)})
          )
        }).filter(tile => tile !== null);

        return (
						<Box
							component="section"
							sx={{
								display: "grid",
								gap: 2,
								gridTemplateColumns: {
									xs: "repeat(2, 1fr)",
                sm: "repeat(2, 1fr)",
                md: finalTiles.length <= 4 ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
								},
							}}
						>
            {finalTiles}
						</Box>
				);
			}}
		</overviewForm.Field>
	);
};
